export class GetWeeklyNamazReportsRequest {
  public cmd: string = "get_weekly_namaz_reports";
  constructor(public majlis: string, public weekRanges: string) { }
}
